import {AfterViewInit, Component, Input, ViewChild} from "@angular/core";
import {List, Events} from "ionic-angular";
import {SignaturePad} from "angular2-signaturepad/signature-pad";
import {TranslateService} from "@ngx-translate/core";
import {JobService} from "../shared/job.service";
import {ToastService} from "../../../app/core/toast.service";
import {Job} from "../shared/job.model";

@Component({
  selector: 'app-job-signatures',
  templateUrl: 'job-signatures.component.html',
})
export class JobSignaturesComponent implements AfterViewInit {
  @ViewChild(SignaturePad) signaturePad: SignaturePad;
  @ViewChild(List) list: List;
  @Input() job: Job;
  sigPadOptions = {
    canvasHeight: 100
  };
  signature = null;
  name = null;

  constructor(private jobService: JobService,
              private toast: ToastService,
              private translate: TranslateService,
              private events: Events) {
  }

  ngAfterViewInit() {
    let contentEl = this.list.getNativeElement();
    let width = contentEl.clientWidth - 40;
    this.signaturePad.set('canvasWidth', width);
  }

  clear(){
    this.signaturePad.clear();
  }

  saveSignature() {
    if (this.signaturePad.isEmpty()) {
      return this.toast.show(this.translate.instant('contract.please_sign'));
    }

    this.jobService.addSignature(this.job.id, this.signaturePad.toDataURL(), this.name)
      .subscribe((res) => {
        this.toast.show(res.message);
        this.clear();
        this.events.publish('job:updated');
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/job/job-signatures/job-signatures.component.ts